<div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <img class="d-block w-100" src="../../../assets/img/carousel/img01.jpeg" alt="First slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="../../../assets/img/carousel/img02.jpeg" alt="Second slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="../../../assets/img/carousel/img02.jpg" alt="Third slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="../../../assets/img/carousel/img04.jpg" alt="Four slide">
        </div>
        <div class="carousel-item">
            <img class="d-block w-100" src="../../../assets/img/carousel/img03.jpeg" alt="Five slide">
        </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon btn-carousel" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon btn-carousel" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>